import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import classnames from 'classnames';
import {
  Button,
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  Nav,
} from 'reactstrap';
import $ from 'jquery';
import { injectIntl } from 'react-intl';

import { setSidebarOpen } from '../actions/App';

import SearchV2 from './SearchV2';
import SupportLink from './SupportLink';
import SidebarCollectionSwitch from './SidebarCollectionSwitch';
import UploadButton from './UploadButton';
import WatchTourButtonButton from './WatchTourButton';
import SidebarCollapseButton from './SidebarCollapseButton';
import SidebarShort from './SidebarShort';

import { isSecondSidebarHiddenOnLocation } from '../helpers/App';

class Toolbar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  toggle() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  toggleSidebar() {
    const {
      sidebarOpen,
      setOpen,
    } = this.props;

    if (!sidebarOpen) {
      const toggler = $('.toolbar-navbar-toggler').offset().top;
      $('.sidebar .sidebar-nav').css('top', toggler + 45);
    }

    setOpen(!sidebarOpen);
  }

  render() {
    const { isOpen } = this.state;
    const {
      location,
      sidebarOpen,
      intl,
    } = this.props;

    const hidden = isSecondSidebarHiddenOnLocation(location);
    const isCustomPageEdit = /^\/admin\/pages\/\d+\/edit$/.test(location.pathname);

    return (
      <div className="toolbar">
        <Container fluid>
          <Navbar light className={classnames('navbar-expand', { 'navbar-admin-custom-page': isCustomPageEdit })}>
            {isCustomPageEdit && (
              <Button
                color="link"
                size="sm"
                tag={Link}
                to="/admin/pages"
                className="mr-2"
              >
                <i className="far fa-arrow-left mr-1" />
                {intl.formatMessage({ defaultMessage: 'Back to Content Portals' })}
              </Button>
            )}
            {hidden ? (
              <div className="hidden">
                <UploadButton />
              </div>
            ) : (
              <>
                <div className="toolbar-buttons toolbar-buttons-left">
                  <SidebarCollapseButton />
                  <SidebarShort />
                </div>
                <div className="toolbar-forms">
                  <SearchV2 />
                </div>
                <div className="toolbar-buttons">
                  <div className="toolbar-navbar-toggler">
                    <Button color="primary" className={classnames('navbar-toggler', { active: sidebarOpen })} onClick={this.toggleSidebar} aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}>
                      <i className="fas fa-bars" />
                    </Button>
                  </div>
                  <div className="toolbar-all-buttons">
                    <SidebarCollectionSwitch />
                    <UploadButton />
                    <NavbarToggler onClick={this.toggle} aria-label={isOpen ? 'Close menu' : 'Open menu'} />
                    <Collapse isOpen={isOpen} navbar className="nav-actions">
                      <Nav className="ml-auto" navbar>
                        <WatchTourButtonButton />
                        <SupportLink />
                      </Nav>
                    </Collapse>
                  </div>
                </div>
              </>
            )}
          </Navbar>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sidebarOpen: state.App.sidebarOpen,
});

const mapDispatchToProps = (dispatch) => ({
  setOpen: (open) => {
    dispatch(setSidebarOpen(open));
  },
});

Toolbar.propTypes = {
  setOpen: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Toolbar)));
